export var Size;
(function (Size) {
    Size[Size["Medium"] = 500] = "Medium";
})(Size || (Size = {}));
export var Padding;
(function (Padding) {
    Padding[Padding["XSmall"] = 8] = "XSmall";
    Padding[Padding["Small"] = 12] = "Small";
    Padding[Padding["Medium"] = 16] = "Medium";
    Padding[Padding["Large"] = 20] = "Large";
})(Padding || (Padding = {}));
export var Margin;
(function (Margin) {
    Margin[Margin["XXSmall"] = 2] = "XXSmall";
    Margin[Margin["XSmall"] = 4] = "XSmall";
    Margin[Margin["Small"] = 10] = "Small";
    Margin[Margin["Medium"] = 12] = "Medium";
    Margin[Margin["Large"] = 16] = "Large";
    Margin[Margin["XLarge"] = 20] = "XLarge";
    Margin[Margin["XXLarge"] = 28] = "XXLarge";
})(Margin || (Margin = {}));
//# sourceMappingURL=Modal.js.map